import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

import "./assets/css/common.css";

const app = createApp(App);

app.use(store).use(Antd).use(router).mount('#app')
